<template>
  <div v-if="showPartnerHeader" class="become-partner">
    <a
      data-google-interstitial="false"
      :class="btnClass"
      :href="partnerUrl"
      v-on:click.stop.prevent="onBecomePartner"
      :data-dl-subscription-params="getDatalayerSubscriptionParams"
    >{{ partnerText }}</a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'edi-partner',
  props: {
    showPartnerHeader: Boolean,
    partnerText: String,
    partnerUrl: String,
    datalayerSubscriptionParams: Object,
    btnClass: String
  },
  computed: {
    ...mapGetters(['redirectUrl']),
    getDatalayerSubscriptionParams() {
      return JSON.stringify(this.datalayerSubscriptionParams);
    }
  },
  methods: {
     onBecomePartner() {
      fetch(`${this.redirectUrl}?op=saveref`, { method: 'GET' })
        .then(() => {
          // aquí deberíamos comprobar si res.status !== 200 o !res.ok para
          // validar el estado de la respuesta, pero el servicio de api
          // de callback devuelve siempre 404, así que no comprobamos nada.
          window.location.href = this.partnerUrl;
        })
        .catch((err) => console.error(err));
    },
  },
}
</script>
